import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import AgenciesPage from "./pages/AgenciesPage";
import LeadMagnetPage from "./pages/LeadMagnetPage";
import ThankYouPage from "./pages/ThankYouPage";
import LeadThankYouPage from "./pages/LeadThankYouPage";
import AdminConfigPage from "./pages/AdminConfigPage";
import AdminLeadsPage from "./pages/AdminLeadsPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import CookiesPolicyPage from "./pages/CookiesPolicyPage";
import CookieBanner, { getCookieConsent } from "./components/CookieBanner";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { loadMetaPixel } from "./lib/metaPixel";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function loadGTM(gtmId) {
  if (!gtmId || document.getElementById("gtm-script")) return;

  const script = document.createElement("script");
  script.id = "gtm-script";
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `;
  document.head.appendChild(script);

  const noscript = document.createElement("noscript");
  noscript.id = "gtm-noscript";
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.insertBefore(noscript, document.body.firstChild);
}

function App() {
  // Load GTM (analytics consent) and Meta Pixel (marketing consent)
  useEffect(() => {
    let gtmId = null;
    let pixelId = null;

    const tryLoad = () => {
      const consent = getCookieConsent();
      if (!consent) return;
      if (consent.analytics && gtmId) loadGTM(gtmId);
      if (consent.marketing && pixelId) loadMetaPixel(pixelId);
    };

    const fetchConfigAndLoad = async () => {
      try {
        const response = await axios.get(`${API}/config`);
        gtmId = response.data?.gtm_id || null;
        pixelId = response.data?.meta_pixel_id || null;
        tryLoad();
      } catch {
        // config not available
      }
    };

    fetchConfigAndLoad();

    const handler = () => tryLoad();
    window.addEventListener("cookie-consent-change", handler);
    return () => window.removeEventListener("cookie-consent-change", handler);
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/agencias" element={<AgenciesPage />} />
            <Route path="/guia-podcast" element={<LeadMagnetPage />} />
            <Route path="/gracias" element={<ThankYouPage />} />
            <Route path="/propuesta-recibida" element={<LeadThankYouPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route
              path="/admin/config"
              element={
                <ProtectedRoute>
                  <AdminConfigPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/leads"
              element={
                <ProtectedRoute>
                  <AdminLeadsPage />
                </ProtectedRoute>
              }
            />
            <Route path="/politica-privacidad" element={<PrivacyPolicyPage />} />
            <Route path="/politica-cookies" element={<CookiesPolicyPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <CookieBanner />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
